/* eslint-disable @typescript-eslint/naming-convention */
export enum LinksButtonTypesEnum {
    Add,
    Edit,
    Delete,
    Custom
}
